import { Box, Button, Grid, Hidden, Paper, Typography } from '@material-ui/core';
import React from 'react';
import useStyle from './styles';
import lockContent from '../../images/lockContent.png'
import isCordova from '../../helpers/cordova-check';

const DOMAIN = process.env.REACT_APP_API_URL

function InsiderCard({ button, expireDate, image, intro, name, description, position, chartName, netWorth, currency, featuredNumber, featuredName }) {
  const classes = useStyle();
  return (
    <Paper elevation={0} className={classes.cardPaperMain}>
      <Grid container style={{ height: '100%' }} direction="column" alignItems="center" justify="space-between" justifyContent="space-between">
        <Grid className={classes.containerCard} item container direction="column" alignItems="center">
          <Box mb={4}>
            <img
              height={137}
              src={image}
              alt="avatar"
            />
          </Box>
          <Typography align="center" variant="h5">
            <Box mb={1}>
              {name}
            </Box>
          </Typography>
          <Typography align="center" style={{ opacity: 0.3, fontWeight: 700 }} variant="body2">
            <Box mb={2}>
              {intro}
            </Box>
          </Typography>
          <Typography style={{ opacity: 0.7 }} align="center" variant="body2">
            {description}
          </Typography>
        </Grid>
        <Hidden smUp>
          <Grid container style={{ maxWidth: 250, paddingBottom: 10 }} justify="center" justifyContent="center" alignItems="center" direction="column">
            {position &&
              <Grid item container align="center" justify="space-between" justifyContent="space-between" style={{ padding: '12px 0', borderBottom: '1px solid #D7DDE3' }} direction="row" >
                <Grid alignItems="center" justify="center" justifyContent="center" item >
                  <Typography align="center" color="primary" variant="h6" style={{ fontWeight: 700, }}>
                    {position}
                  </Typography>
                </Grid>
                <Grid alignItems="center" justify="center" justifyContent="center" item >
                  <Typography align="center" style={{ fontSize: 12, color: '#85C4FF' }}>
                    {chartName}
                  </Typography>
                </Grid>
              </Grid>
            }
            {netWorth &&
              <Grid item container align="center" justify="space-between" justifyContent="space-between" style={{ padding: '12px 0', borderBottom: '1px solid #D7DDE3' }} direction="row" >
                <Grid alignItems="center" justify="center" justifyContent="center" item >
                  <Typography align="center" color="primary" variant="h6" style={{ fontWeight: 700, }}>
                    {netWorth}
                  </Typography>
                </Grid>
                <Grid alignItems="center" justify="center" justifyContent="center" item  >
                  <Typography align="center" style={{ fontSize: 12, color: '#85C4FF' }}>
                    {currency}
                  </Typography>
                </Grid>
              </Grid>
            }
            {featuredName &&
              <Grid item container align="center" justify="space-between" justifyContent="space-between" style={{ padding: '12px 0' }} direction="row" >
                <Grid alignItems="center" justify="center" justifyContent="center" item>
                  <Typography align="center" color="primary" variant="h6" style={{ fontWeight: 700, }}>
                    {featuredNumber}
                  </Typography>
                </Grid>
                <Grid alignItems="center" justify="center" justifyContent="center" item >
                  <Typography align="center" style={{ fontSize: 12, color: '#85C4FF' }}>
                    {featuredName}
                  </Typography>
                </Grid>
              </Grid>
            }
            <div className={classes.expireDate}>
              {expireDate ? expireDate : ' '}
            </div>
          </Grid>
        </Hidden>
        <Hidden xsDown >
          <Grid container style={{ padding: '0 10px', }} item alignItems="center" direction="column">
            <Grid item container direction="row" >
              {position &&
                <Grid alignItems="center" justify="center" justifyContent="center" item xs={4} style={{ borderRight: '1px solid #BFC4C8' }}>
                  <Typography align="center" color="primary" variant="h6" style={{ fontWeight: 700, }}>
                    {position}
                  </Typography>
                </Grid>
              }
              {netWorth &&
                <Grid alignItems="center" justify="center" justifyContent="center" item xs={4} style={{ borderRight: '1px solid #BFC4C8' }}>
                  <Typography align="center" color="primary" variant="h6" style={{ fontWeight: 700, }}>
                    {netWorth}
                  </Typography>
                </Grid>
              }
              {featuredName &&
                <Grid alignItems="center" justify="center" justifyContent="center" item xs={4}>
                  <Typography align="center" color="primary" variant="h6" style={{ fontWeight: 700, }}>
                    {featuredNumber}
                  </Typography>
                </Grid>
              }
            </Grid>
            <Grid item container direction="row" >
              {chartName &&
                <Grid alignItems="center" justify="center" justifyContent="center" item xs={4} style={{ borderRight: '1px solid #BFC4C8' }}>
                  <Typography align="center" style={{ fontSize: 12, padding: '0px 5px', color: '#85C4FF' }}>
                    {chartName}
                  </Typography>
                </Grid>
              }
              {currency &&
                <Grid alignItems="center" justify="center" justifyContent="center" item xs={4} style={{ borderRight: '1px solid #BFC4C8' }}>
                  <Typography align="center" style={{ fontSize: 12, padding: '0px 5px', color: '#85C4FF' }}>
                    {currency}
                  </Typography>
                </Grid>
              }
              {featuredName &&
                <Grid alignItems="center" justify="center" justifyContent="center" item xs={4}>
                  <Typography align="center" style={{ fontSize: 12, padding: '0px 5px', color: '#85C4FF' }}>
                    {featuredName}
                  </Typography>
                </Grid>
              }
            </Grid>
            <Grid container style={{ paddingBottom: 30 }} item direction="row" justify="space-around" justifyContent="space-around">
              {
                button.map(item => {
                  if (item.lock === true) {
                    return <Button
                      onClick={isCordova() ? () => window.open(DOMAIN + item.buttonUrl, '_blank') : () => window.open(item.buttonUrl, '_blank')}
                      variant="contained" color="primary" className={classes.startButton} >
                      <img
                        alt="lockButton"
                        src={lockContent}
                        width="30px"
                        style={{ marginRight: 5, }}
                      >
                      </img>
                      <Typography align="center" variant="subtitle1">
                        <Box color="white" fontWeight={700} >
                          {item.buttonText}
                        </Box>
                      </Typography>
                    </Button>
                  } else
                    return <Button
                      onClick={() => window.open(item.buttonUrl, '_blank')}
                      variant="contained" color="primary" className={classes.startButton} >
                      {item.buttonText}
                    </Button>
                })
              }
            </Grid>
          </Grid>
        </Hidden>
      </Grid>
    </Paper >
  );
}

export default InsiderCard;